export default "/staticreactui/static/media/static/media/customer1.ce0eadf7.webp";